<template>
    <b-button
        variant="success"
        @click.stop="atualizarFiscalizacao()"
        class="mr-2">
        <i class="fa fa-edit"></i> Atualizar fiscalização
    </b-button>
</template>

<script>

export default {
    methods: {
        atualizarFiscalizacao() {
            this.$router.push({
                name: 'Fiscalizações_Atualizar',
                params: { fiscalizacaoId: this.$route.params.fiscalizacaoId }
            })
        },
    },
}
</script>